import logo from "../img/logo_desc_white.png";
import React from "react";

const LogoSquareWhite:React.FC = () => (
  <div className="sklogo">
    <img src={logo} alt="Skoltech" style={{width: "100%"}}/>
  </div>
);

export default LogoSquareWhite;